var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEndWorkout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.05,
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#27AE60"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 30C43.4582 30 30 43.4582 30 60C30 76.5418 43.4582 90 60 90C76.5418 90 90 76.5418 90 60C90 43.4582 76.5418 30 60 30ZM54.5192 75.0548L42.8942 62.1361L46.3255 59.0481L54.4024 68.0221L73.5577 45.2106L77.0971 48.1731L54.5192 75.0548Z",
    fill: "#27AE60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndWorkout);
export default __webpack_public_path__ + "static/media/endWorkout.886e8bd053a46233753f2da393cca323.svg";
export { ForwardRef as ReactComponent };